export { default as CustomDropDown } from './form/CustomDropDown'
export { default as CustomTextArea } from './form/CustomTextArea'
export { default as CustomDatePicker } from './form/CustomDatePicker'
export { default as CustomInput } from './form/CustomInput'
export { default as ActionButton } from './ActionButton'
export { default as Error } from 'custom-error'
export { default as CustomChipsGroup } from './CustomChipsGroup'
export { default as CustomRadio } from './CustomRadio'
export { default as CustomCollapse } from './CustomCollapse'
export { default as CustomCollapseItem } from './CustomCollapseItem'
export { default as FooterButtons } from './FooterButtons'
export { default as CustomTitleDivider } from './CustomTitleDivider'
export { default as CustomLink } from './CustomLink'
export { default as CustomCallout } from './CustomCallout'
export { default as CustomCheckBox } from './checkbox/View.vue'

// Lista de colores
const colors = Object.freeze({
    GREEN: 'green',
    BROWN: 'brown',
    YELLOW: 'yellow',
    PINK: 'pink',
    VIOLET: 'violet',
});

export const Colors = colors;

